import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Flex,
  Text,
  Box,
  Tooltip,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Spinner,
  Grid,
  Heading,
  Select,
} from "@chakra-ui/react";

import { FaArrowDown, FaArrowUp, FaEdit } from "react-icons/fa";
import { RiDeleteBin5Line, RiLockPasswordLine } from "react-icons/ri";
import SearchBox from "components/layouts/MainWindow/Navbar/SearchBox";

import BsesUserModal from "./BsesUserModal";

import DeleteModal from "components/layouts/MainWindow/Admin/DeleteModal";
import ResetPasswordFormModal from "components/Auth/ResetPasswordFormModal";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";

import _ from "lodash";
import { HiOutlineRefresh } from "react-icons/hi";
import { Paginationlimit } from "components/common/functions/variable";
import Pagination from "components/common/Pagination/Pagination";


type User = {
  id: string;
  name: string;
  email: string;
  moNumber: string;
  username: string;
  role: string;
  type: string;
  permission: any;
};

type sortBy = {
  _id: string;
  label: string;
  option: string;
};

const options: sortBy[] = [
  {
    _id: "1",
    label: "allUsers",
    option: "All Users",
  },
  {
    _id: "2",
    label: "recentlyAdded",
    option: "Recently Added",
  },
];

export default function UsersPage(): JSX.Element {
  const { toastNotify } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  // const [searchValue, setSearchValue] = useState("");

  // Create New User lightbox
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  // const [newPage, setNewPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [data, setData] = useState<User[]>([]);
  const [modalData, setModalData] = useState<User>();
  const [sortBy, setSortedBy] = useState("allUsers");
  const [itemId, setItemId] = useState("");
  const [index, setIndex] = useState<number>();

  const handleOpenModal = () => {
    setIsOpen(true);
  };
  const handleCloseModal = () => {
    setIsOpen(false);
  };

  //   User Edit Modal
  const [isEditOpen, setIsEditOpen] = useState(false);
  const handleOpenEditModal = (item: any) => {
    setIsEditOpen(true);
    setModalData(item);
  };
  const handleCloseEditModal = () => {
    setIsEditOpen(false);
    setModalData(undefined);
  };

  //   Delete Modal
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const handleOpenDeleteModal = (item: any, index: number) => {
    setIsDeleteOpen(true);
    setItemId(item.id);
    setIndex(index);
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteOpen(false);
  };

  //   Change Password Modal
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
  const handleOpenChangePasswordModal = (item: any, index: number) => {
    setIsChangePasswordOpen(true);
    setItemId(item.id);
    setIndex(index);
  };

  const handleCloseChangePasswordModal = () => {
    setIsChangePasswordOpen(false);
  };

  const handleGetUser = async (currentP?: number, valu?: any) => {
    try {
      setLoading(true);
      let value = valu ? valu : search;
      let filter = sortBy;
      let limit = Paginationlimit;
      let sort = 1;
      let page = currentP ? currentP : currentPage;
      const response: any = await appRequest("user", "get", {
        value,
        filter,
        limit,
        sort,
        page,
      });
      console.log(response);
      if (response) {
        if (Array.isArray(response.data)) {
          setData(response.data);
          setTotalPages(response?.totalPages);
        } else {
          setData([]);
        }
      } else {
        toastNotify({
          title: `Error getting the user.`,
          message: response.message || "Something went wrong.",
          type: "error",
        });
      }
    } catch (error: any) {
      toastNotify({
        title: `Error getting the user.`,
        description: error.message || "Something went wrong.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (initialLoad) {
      handleGetUser(currentPage);
      setInitialLoad(false);
    } else {
      const debounceSearch = _.debounce((value) => {
        handleGetUser(currentPage, value);
      }, 1500);
      debounceSearch(search);
      return () => {
        debounceSearch.cancel();
      };
    }
  }, [search, currentPage, sortBy]);

  // User Table

  const [sortDir, setSortDir] = useState<"asc" | "desc">("asc");
  const [sortCol, setSortCol] = useState<
    "id" | "name" | "moNumber" | "email" | "role"
  >("id");

  const handleSort = (col: "id" | "name" | "moNumber" | "email" | "role") => {
    if (sortCol === col) {
      setSortDir(sortDir === "asc" ? "desc" : "asc");
    } else {
      setSortCol(col);
      setSortDir("asc");
    }
  };

  // Serch box
  const handleSearch = (value: string) => {
    // Do something with the search value
    setSearch(value);
  };

  const handlePageChange = (page: any) => {
    setCurrentPage(page.selected + 1);
  };

  return (
    <>
      <Box
        mt="1rem"
        boxShadow="rgb(0 0 0 / 12%) 0px 0px 11px"
        rounded={8}
        p="1.5rem 1.5rem"
        bg="white"
      >
        <Grid
          templateColumns={{ md: "1fr auto" }}
          alignItems="center"
          justifyContent="space-between"
          gap="1rem"
        >
          <Heading fontSize={{ base: "1.125rem", lg: "1.6rem" }}>
            <Button
              type="submit"
              bg="teal.300"
              // h={{ base: "35px", lg: "45px" }}
              fontWeight="500"
              color="white"
              _hover={{
                bg: "teal.400",
              }}
              onClick={handleOpenModal}
            >
              Create New Userssss
            </Button>
          </Heading>
          <Flex gap={{ base: "0.5rem", lg: "1rem" }}>
            <Box w="10rem">
              <Select
                placeholder="Sort by"
                fontSize="sm"
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearch("");
                  setSortedBy(e.target.value);
                }}
              >
                {options &&
                  options.map((item, index) => (
                    <option key={index} value={item.label}>
                      {item.option}
                    </option>
                  ))}
              </Select>
            </Box>
            <Box w={{ base: "auto", lg: "15rem" }}>
              <SearchBox
                onSearch={handleSearch}
                value={search}
                setValue={setSearch}
              />
            </Box>

            <Button
              border="2px solid"
              borderColor="teal.300"
              bg="white"
              fontSize="sm"
              color="teal.400"
              w={{ base: "auto", lg: "8rem" }}
              _hover={{ bg: "teal.300", color: "white" }}
              onClick={() => {
                setCurrentPage(1);
                setSearch("");
                handleGetUser();
              }}
            >
              <HiOutlineRefresh fontSize="1.2rem" />
              <Text display={{ base: "none", lg: "block" }}>
                &nbsp; Refresh
              </Text>
            </Button>
          </Flex>
        </Grid>
        <Box
          position="relative"
          overflow="auto hidden"
          className="customScrollBar"
        >
          <Table variant="striped" mt="1rem">
            <Thead>
              <Tr>
                <Th onClick={() => handleSort("name")}>
                  <Flex alignItems="center">
                    <Text mr={6}>Name</Text>
                    {sortCol === "name" &&
                      (sortDir === "asc" ? <FaArrowUp /> : <FaArrowDown />)}
                  </Flex>
                </Th>
                <Th>
                  <Text mr={6}>Profile Id</Text>
                </Th>
                <Th onClick={() => handleSort("email")}>
                  <Flex alignItems="center">
                    <Text mr={6}>Email</Text>
                    {sortCol === "email" &&
                      (sortDir === "asc" ? <FaArrowUp /> : <FaArrowDown />)}
                  </Flex>
                </Th>
                <Th onClick={() => handleSort("role")}>
                  <Flex alignItems="center">
                    <Text mr={6} display="none">Role</Text>
                    {sortCol === "role" &&
                      (sortDir === "asc" ? <FaArrowUp /> : <FaArrowDown />)}
                  </Flex>
                </Th>
                {/* | "name" | "" | "" | "role" */}
                <Th></Th>
              </Tr>
            </Thead>
            <Tbody>
              {loading === true ? (
                <Tr>
                  <Td colSpan={5}>
                    <Flex justify="center">
                      <Spinner />
                    </Flex>
                  </Td>
                </Tr>
              ) : data.length === 0 ? (
                <Tr>
                  <Td colSpan={5}>
                    <Flex justify="center">
                      <Text fontSize="sm">No Data Available to Show</Text>
                    </Flex>
                  </Td>
                </Tr>
              ) : (
                data.map((item: any, index) => (
                  <>
                    <Tr key={`table-${index}`}>
                      <Td>{item.name}</Td>
                      <Td>{item.profileId}</Td>
                      <Td>{item.email}</Td>
                      <Td display="none">{item.role}</Td>
                      <Td>
                        <Flex alignItems="center" justifyContent="end">
                          <Tooltip
                            label="Edit this user"
                            hasArrow
                            arrowSize={15}
                          >
                            <Flex
                              alignItems="center"
                              cursor="pointer"
                              mr="2rem"
                              color="green.500"
                              onClick={() => handleOpenEditModal(item)}
                              _hover={{ color: "green.600" }}
                              display="none"
                            >
                              <Box mr=".5rem">
                                <FaEdit />
                              </Box>
                              Edit
                            </Flex>
                          </Tooltip>

                          <Tooltip
                            label="Delete this user"
                            hasArrow
                            arrowSize={15}
                          >
                            <Flex
                              alignItems="center"
                              cursor="pointer"
                              color="red.500"
                              mr="2rem"
                              onClick={() => handleOpenDeleteModal(item, index)}
                              _hover={{ color: "red.600" }}
                              display="none"
                            >
                              <Box mr=".5rem">
                                <RiDeleteBin5Line />
                              </Box>
                              Delete
                            </Flex>
                          </Tooltip>

                          <Tooltip
                            label="Change Password"
                            hasArrow
                            arrowSize={15}
                          >
                            <Flex
                              alignItems="center"
                              cursor="pointer"
                              color="green.500"
                              onClick={() =>
                                handleOpenChangePasswordModal(item, index)
                              }
                              _hover={{ color: "green.600" }}
                            >
                              <Box mr=".5rem">
                                <RiLockPasswordLine />
                              </Box>
                              Change Password
                            </Flex>
                          </Tooltip>
                        </Flex>
                      </Td>
                    </Tr>
                  </>
                ))
              )}
            </Tbody>
          </Table>
        </Box>
        <Pagination
          totalPages={totalPages}
          handlePageChange={handlePageChange}
        />
      </Box>
      <DeleteModal
        isUser={true}
        isOpen={isDeleteOpen}
        onClose={handleCloseDeleteModal}
        id={itemId}
        request={{ type: "user", requestType: "delete" }}
        handleUpdate={handleGetUser}
        key={`delete-${index}`}
      />
      <ResetPasswordFormModal
        isCurrentPass={false}
        isOpen={isChangePasswordOpen}
        onClose={handleCloseChangePasswordModal}
        key={`reset-${index}`}
        id={itemId}
      />
      {isOpen && (
        <BsesUserModal
          isPassword={true}
          isOpen={isOpen}
          onClose={handleCloseModal}
          handleGetUser={handleGetUser}
          type="Add"
          key={"add-1"}
        />
      )}

      {isEditOpen && (
        <BsesUserModal
          isPassword={false}
          isOpen={isEditOpen}
          onClose={handleCloseEditModal}
          handleGetUser={handleGetUser}
          key={`edit-1`}
          type="Edit"
          data={modalData}
        />
      )}
    </>
  );
}
